<template>
  <div id="app">
    <!-- 头部 -->
    <Head></Head>
    <router-view></router-view>
    <!-- 尾部 -->
    <Foot></Foot>
  </div>
</template>

<script>
import Head from "./components/head"
import Foot from './components/foot';
export default {
  name: 'App',
  components:{
    Head,Foot
  },
  data () {
    return {
      type:true
    } 
  },
  watch:{
    $route(to,from){      
      document.getElementById('app').scrollTo(0, 0)
    }
  },
  mounted(){
    window.addEventListener('resize', this.setRem)

  },
  methods:{
    setRem () {
      let width = document.getElementById('app').offsetWidth
      let fontSize = parseInt(
        100 - ((1920 - width) * (100 - 80)) / (1920 - 1366)
      )
      document.documentElement.style.fontSize = fontSize + 'px'
    }

  }
}
</script>

<style lang="scss">
body{
  margin: 0;
  padding: 0;
}
  #app{
    width: 100vw;
    height: 100vh;
    font-size: 0.2rem;
    overflow: scroll;
    position: relative;    
  }
  ::-webkit-scrollbar{
    width: 10px;
    height: 1px;
  }
  ::-webkit-scrollbar-thumb { //滑块部分
    border-radius: 5px;
    background-color: #ccc
  }
  ::-webkit-scrollbar-track { //轨道部分
    // box-shadow: inset 0 0 5px rgba(0,0,0,0.1);
    background: #ededed;
    border-radius: 5px;

  }
  
</style>